<template>
  <div am-filter-item>
    <i-tooltip placement="bottom" v-if="filteredBy.join(', ').length > 20">
      <i-button @click="toogleOpen">
        {{
          this.$route.query.filter && filteredBy.length > 0
          ? 'Filtered by ' +
            filteredBy.join(', ').substr(0, 20) + '...'
            : 'Filter'
        }}
      </i-button>
      <template #body>
        <p class="_white-space:normal">{{filteredBy.join(', ')}}</p>
      </template>
    </i-tooltip>
    <i-button v-else @click="toogleOpen">
      {{
        this.$route.query.filter && filteredBy.length > 0 ?
          'Filtered by ' + filteredBy.join(', ') :
          'Filter'
      }}
    </i-button>
    <i-card v-if="isOpen" am-filter-body v-click-outside="close">
      <p>Where</p>
      <div
        v-for="(item, index) in filter"
        :key="index"
        :class="item.field === 'attrs' ? '' : '_display:flex _align-items:center _flex:wrap _margin-bottom:1'"
      >
        <div am-del-field-icon>
          <svg
            viewBox="0 0 24 24"
            am-icon
            style="fill: var(----color);"
            class="_margin-right:1/2 _margin-bottom:1/2"
            @click="delFilter(index)"
            v-if="filter.length > 0"
          >
            <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
        <i-dropdown class="_margin-right:1/2 _margin-bottom:1/2">
          <i-button
            am-select-button
            class="_display:flex _align-items:center _justify-content:space-between"
          >
            {{ item.field ? item.field === 'element_types' ? 'Compatible Types' : item.field[0].toUpperCase() + item.field.slice(1) : 'Choose field..' }}
            <svg am-icon viewBox="0 0 24 24" style="fill: var(----color); min-width:16px">
              <use xlink:href="@/assets/icons.svg#select-carret" x="0" y="0" width="24" height="24"></use>
            </svg>
          </i-button>
          <template #body>
            <i-dropdown-item
              v-for="field in options"
              :key="field"
              @click="setField(index, field)"
            >
              {{ field === 'element_types' ? 'Compatible Types' : field[0].toUpperCase() + field.slice(1) }}
            </i-dropdown-item>
          </template>
        </i-dropdown>
        <div
          v-if="item.field === 'algs'"
          :class="`_display:flex _flex:wrap _align-items:center _margin-bottom:1/2`"
        >
          <p class="_margin:1/2">any of</p>
          <div
            v-for="(algoritm, index) in item.values"
            :key="index"
            class="_display:inline-flex _align-items:center _margin-bottom:1 _margin-top:1 _margin-right:1/2"
          >
            <algorithm-input
              :alg="item.values[index]"
              @update="(n)=> {
                item.values[index] = n.data;
                if (n.error) return
                putFilterData()
              }"
              @delete="index === 0 ? item.values[0] = '' : item.values.splice(index, 1); putFilterData()"
            />
          </div>
          <svg am-icon viewBox="0 0 24 24" class="_margin-bottom:1/3" style="min-width:1rem" @click="item.values.push('')">
            <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
        <div v-if="item.field === 'params'" class="_display:flex _flex:wrap _margin-bottom:1/2">
          <div
            v-for="(param, i) in item.values"
            :key="param"
            class="_display:flex"
            style="margin-bottom: 24px; margin-top: 24px"
          >
            <div class="_position:relative _display:flex" style="height: 42px;">
              <input-condition
                v-model="param.key"
                placeholder="key"
                @change="(event)=>watchKey(event, i)"
                :error="paramKeyError[i]"
                errorMessage="завтал, waistband, ruffle, cuff, lining, facing, numbers, elastik, loop, facing_t"
              />
              <p class="_margin-left:1"></p>
              <input-condition
                v-model="param.value"
                @keypress="watchValue"
                placeholder="value"
                @change="putFilterData"
              />
            </div>
            <svg
              viewBox="0 0 24 24"
              am-icon
              style="fill: var(----color); height: 40px;"
              class="_margin-left:1/2"
              @click="delParam(i, item.values)"
            >
              <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
            </svg>
            <i-button
              class="_margin-left:1"
              v-if="item.values.length - 1 === i"
              @click="item.values.push({ key: '', value: '' })"
            >
              AND
            </i-button>
            <div v-else class="_margin-left:1 _margin-right:1" style="line-height: 40px;">and</div>
          </div>
        </div>
        <div v-if="item.field === 'step'" class="_display:flex _align-items:center _margin-bottom:1/2">
          <p class="_margin-right:1/2">=</p>
          <i-input
            type="number"
            v-model="item.values.value"
            placeholder="Step number"
            @change="putFilterData"
          />
        </div>
        <div
          am-content
          v-if="item.field === 'content'"
          class="_display:flex _align-items:center _margin-bottom:1/2"
        >
          <p class="_margin-right:1/2">contains</p>
          <content-input v-model="item.values.value" @change="putFilterData" />
        </div>
        <div v-if="item.field === 'element_types'" style="min-width:100%;">
          <div class="_display:flex _flex-wrap:wrap _align-items:center">
            <p class="_margin:1/4">any of</p>
            <i-badge
              color="success"
              v-for="(type, index) in item.values"
              :key="index"
              am-tag-badge
              class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
            >
              <p>{{ type }}</p>
              <div class="_display:flex _align-items:center">
                <svg
                  am-icon
                  @click="() => {
                    item.values.splice(index, 1);
                    putFilterData()
                  }"
                  viewBox="0 0 24 24"
                  style="fill: var(----color);"
                >
                  <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
                </svg>
              </div>
            </i-badge>
          </div>
          <div>
            <hr>
            <div v-if="loadTypes" class="_display:flex _justify-content:center _width:100%">
              <i-loader color="primary" size="sm" />
            </div>
            <div
              v-else-if="filterElementTypes && filterElementTypes.length > 0"
              class="_display:flex _flex-wrap:wrap _align-items:center"
            >
              <i-badge
                color="primary"
                v-for="type in filterElementTypes"
                :key="type"
                am-tag-badge
                class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                @click="() => {
                  item.values.push(type);
                  putFilterData()
                }"
              >
                <p>{{ type }}</p>
              </i-badge>
            </div>
            <div v-else class="_margin:1/2">
              No results
            </div>
          </div>
        </div>
        <div v-if="item.field === 'attrs'">
          <div class="_display:flex _flex-wrap:wrap _align-items:center">
            <p class="_margin:1/4">any of</p>
            <i-badge
              color="primary"
              v-for="(attr, index) in item.attributes"
              :key="index"
              :am-tag-badge="attr.id % 10"
              class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
            >
              <p>
                {{
                  (attr.type[0].toUpperCase() +
                  attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                  ' : ' + attr.name
                }}
              </p>
              <div class="_display:flex _align-items:center">
                <svg
                  viewBox="0 0 24 24"
                  am-icon
                  style="fill: var(----color);"
                  @click="()=>{
                    item.attributes.splice(index, 1);
                    putFilterData()
                  }"
                >
                  <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
                </svg>
              </div>
            </i-badge>
          </div>
          <div
            am-search-attr
            class="_display:flex _flex-wrap:wrap _align-items:center _margin-top:1/2 _margin-bottom:1/2"
          >
            <i-select
              v-if="attributesTypes"
              v-model="selectedType"
              :options="getAllTypesAttributes"
              placeholder="Choose attributes type.."
              class="_margin-right:1"
              am-block
              autocomplete
              clearable
              @search="setSearchTypeValue"
              @update:modelValue="fetchAllAttributes({
                typeAttr: selectedType ? selectedType.id : null, searchAttr: searchAttr
              })"
            />
            <div am-block>
              <i-input
                v-model="searchValue"
                placeholder="search attr.."
              />
            </div>
          </div>
          <div class="_display:flex _justify-content:center _width:100%">
            <i-loader v-if="loading" color="primary" size="sm" />
          </div>
          <div
            v-if="(selectedType || searchAttr) && !loading && filterAttrs(index) && filterAttrs(index).length > 0"
            class="_padding-top:1 _padding-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
            am-attr-result
          >
            <i-badge
              color="primary"
              v-for="attr in filterAttrs(index)"
              :key="attr.id"
              :am-tag-badge="attr.id % 10"
              class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
              @click="() => {
                item.attributes.push(attr);
                putFilterData()
              }"
            >
              <p>
                {{
                  (attr.type[0].toUpperCase() +
                  attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                  ' : ' + attr.name
                }}
              </p>
            </i-badge>
          </div>
          <div
            v-if="(selectedType || searchAttr) && !loading && (!filterAttrs(index) || filterAttrs(index).length === 0)"
            class="_padding:1/2"
          >
            No results
          </div>
        </div>
      </div>
      <div :class="`_display:flex ${filter.length < 6 ? '_justify-content:space-between' : '_justify-content:end'}`">
        <i-button
          v-if="filter.length < 6"
          link
          color="primary"
          @click="addConditions"
          class="_padding:0"
        >
          Add conditions
        </i-button>
        <i-button
          v-if="filter[0].field"
          link
          color="light"
          @click="resetFilter()"
          class="_padding:0"
        >
          Reset filter
        </i-button>
      </div>
    </i-card>
  </div>
</template>

<script>
import contentInput from './contentInput.vue'
import algorithmInput from './algorithmInput.vue'
import inputCondition from './inputCondition.vue'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    contentInput,
    algorithmInput,
    inputCondition
  },
  data: () => ({
    isOpen: false,
    paramKeyError: {},
    searchAttr: '',
    timer: null,
    selectedType: null,
    searchType: null,
    options: ['params', 'attrs', 'algs', 'step', 'content', 'element_types'],
    filter: [
      {
        field: null,
        values: null
      }
    ],
    filteredBy: []
  }),
  watch: {
    '$route' (to, from) {
      if (JSON.stringify(to.params) !== JSON.stringify(from.params) && to.name !== 'InstructionForm') {
        this.resetFilter()
      }
    }
  },
  computed: {
    ...mapState('attributes', ['loading', 'allAttr', 'attributesTypes']),
    ...mapState('instructions', ['types', 'loadTypes']),
    ...mapGetters('attributes', ['getAllTypesAttributes']),
    searchValue: {
      get () {
        return this.searchAttr
      },
      set (value) {
        this.searchAttr = value
        clearTimeout(this.timer)
        this.timer = window.setTimeout(() => {
          this.fetchAllAttributes({
            typeAttr: this.selectedType ? this.selectedType.id : null,
            searchAttr: value
          })
        }, 500)
      }
    },
    filterElementTypes () {
      const types = this.filter.find(el => el.field === 'element_types')
      if (types && this.types[this.table]) return this.types[this.table].filter(el => !types.values.includes(el))
      return this.types[this.table] || []
    },
    table () {
      return this.$route.params.subtable.split('-')[0]
    }
  },
  async mounted () {
    if (this.attributesTypes.length === 0) {
      await this.fetchAttributesTypes()
    }
    if (this.$route.query.filter) {
      const filterArray = JSON.parse(this.$route.query.filter)
      if (filterArray && filterArray.length > 0) {
        this.filter = []
        filterArray.forEach(async el => {
          this.options = this.options.filter(option => option !== el.field)
          if (el.field === 'params') {
            const paramsString = []
            Object.keys(el.values).forEach(param => {
              paramsString.push(`${param}:${el.values[param].join(', ')}`)
            })
            this.filteredBy.push(`${el.field} = ${paramsString.join(', ')}`)
            this.filter.push({
              field: 'params',
              values: []
            })
            for (const key in el.values) {
              const value = el.values[key] instanceof Array ? el.values[key].join() : el.values[key]
              this.filter[this.filter.length - 1].values.push({ key: key, value: value })
            }
          } else if (el.field === 'attrs') {
            const attributesString = []
            JSON.parse(this.$route.query.attrs).forEach(attr => {
              attributesString.push(
                (attr.type[0].toUpperCase() +
                attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                ' : ' + attr.name
              )
            })
            this.filteredBy.push(`${el.field} = ${attributesString.join(', ')}`)
            if (this.$route.query.attrs) {
              this.filter.push({
                field: 'attrs',
                attributes: JSON.parse(this.$route.query.attrs)
              })
            }
          } else if (el.field === 'algs' || el.field === 'element_types') {
            this.filteredBy.push(`${el.field} = ${el.values.join(', ')}`)
            this.filter.push(el)
            if (el.field === 'element_types') await this.getTypes({ categoryId: this.table })
          } else {
            this.filter.push(el)
            this.filteredBy.push(`${el.field} = ${el.values.value}`)
          }
        })
      }
    }
  },
  methods: {
    ...mapMutations('ui', ['closeModal']),
    ...mapMutations('attributes', ['setSearchTypeValue']),
    ...mapActions('attributes', ['fetchAllAttributes', 'fetchAttributesTypes']),
    ...mapActions('instructions', ['getTypes']),
    close () {
      this.isOpen = false
      this.closeModal(null)
    },
    toogleOpen () {
      if (!this.isOpen) {
        this.closeModal(this.close)
      } else this.closeModal(null)
      this.isOpen = !this.isOpen
    },
    resetFilter () {
      this.paramKeyError = {}
      this.searchAttr = ''
      this.selectedType = null
      this.filter = [
        {
          field: null,
          values: null
        }
      ]
      this.options = ['params', 'attrs', 'algs', 'step', 'content', 'element_types']
      this.putFilterData()
    },
    delParam (index, value) {
      if (value.length === 1) {
        value[0].value = ''
        value[0].key = ''
      } else {
        value.splice(index, 1)
      }
      this.putFilterData()
    },
    filterAttrs (index) {
      if (this.allAttr && this.allAttr.length > 0) {
        return this.allAttr.filter((elem) => !this.filter[index].attributes.find(({ id }) => elem.id === id))
      } else return null
    },
    addConditions () {
      this.filter.push({
        field: null,
        values: null
      })
    },
    async setField (index, field) {
      this.options = this.options.filter(el => el !== field)
      if (this.filter[index].field) {
        this.options.push(this.filter[index].field)
      }
      if (field === 'algs') {
        this.filter[index] = {
          field: field,
          values: ['']
        }
      } else if (field === 'step' || field === 'content') {
        this.filter[index] = {
          field: field,
          values: { value: '' }
        }
      } else if (field === 'params') {
        this.filter[index] = {
          field: field,
          values: [{
            key: '',
            value: ''
          }]
        }
      } else if (field === 'attrs') {
        this.filter[index] = {
          field: field,
          attributes: [],
          values: {}
        }
      } else if (field === 'element_types') {
        this.filter[index] = {
          field: field,
          values: []
        }
        await this.getTypes({ categoryId: this.table })
      }
      this.putFilterData()
    },
    delFilter (index) {
      if (this.filter[index].field) {
        this.options.push(this.filter[index].field)
      }
      this.filter.splice(index, 1)
      if (this.filter.length === 0) {
        this.filter = [
          {
            field: null,
            values: null
          }
        ]
      }
      this.putFilterData()
    },
    watchKey (event, i) {
      const data = event.target.value.toLowerCase()
      const regex = /^[0-9]{1,}$|^завтал$|^waistband$|^ruffle$|^cuff$|^lining$|^facing$|^elastik$|^loop$|^facing_t$/g
      const found = regex.test(data)
      if (!found) {
        this.paramKeyError[i] = true
      } else {
        this.paramKeyError[i] = false
        this.putFilterData()
      }
    },
    watchValue (event) {
      const regex = /^[0-9 ,]+$/
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
    },
    putFilterData () {
      const newFilter = []
      this.filteredBy = []
      this.filter.forEach(el => {
        if (el.field) {
          if (el.field !== 'attrs' && el.field !== 'params' && el.values.value) {
            newFilter.push(el)
            this.filteredBy.push(`${el.field} = ${el.values.value}`)
          } else if (el.field === 'attrs' && el.attributes.length > 0) {
            const attributesString = []
            const attrNormal = {}
            el.attributes.forEach(attr => {
              attributesString.push(
                (attr.type[0].toUpperCase() +
                attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                ' : ' + attr.name
              )
              if (!attrNormal[attr.type]) attrNormal[attr.type] = []
              attrNormal[attr.type].push(attr.id)
            })
            this.filteredBy.push(`${el.field} = ${attributesString.join(', ')}`)
            newFilter.push({
              field: 'attrs',
              values: attrNormal
            })
          } else if (el.field === 'params' && el.values.length > 0) {
            const obj = {}
            el.values.forEach(param => {
              let isError = false
              for (const key in this.paramKeyError) {
                if (this.paramKeyError[key] === true) {
                  isError = true
                  return
                }
              }
              if (param.key && param.value && !isError) {
                if (!obj[param.key]) obj[param.key] = []
                if (param.value.includes(',')) {
                  param.value.split(',').forEach(v => {
                    if (v.trim()) {
                      if (!obj[param.key].includes(Number(v.trim()))) obj[param.key].push(Number(v.trim()))
                    }
                  })
                } else {
                  if (!obj[param.key].includes(Number(param.value.trim()))) {
                    obj[param.key].push(Number(param.value.trim()))
                  }
                }
              }
            })
            if (Object.keys(obj).length > 0) {
              const paramsString = []
              Object.keys(obj).forEach(el => {
                paramsString.push(`${el}:${obj[el].join(', ')}`)
              })
              this.filteredBy.push(`${el.field} = ${paramsString.join(', ')}`)
              newFilter.push({
                field: 'params',
                values: obj
              })
            }
          } else if ((el.field === 'algs' || el.field === 'element_types') && el.values.length > 0) {
            newFilter.push(el)
            this.filteredBy.push(`${el.field} = ${el.values.join(', ')}`)
          }
        }
      })
      const isAttrs = this.filter.find(el => el.field === 'attrs')
      this.$emit('update', { filter: newFilter, attrs: isAttrs?.attributes })
    }
  }
}
</script>

<style lang="scss">
[am-filter-item] {
  ----font-size: 0.85rem;
  ----line-height: 1.2;
  ----spacing: 0.25rem;
  ----padding: #{var(----spacing)};
  font-size: var(----font-size);

  [am-filter-body] {
    position: absolute;
    top: 100%;
    max-height: 500px;
    min-width: 250px;
    max-width: 60%;
    overflow: auto;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
  .popover {
    width: auto;
    max-height: 500px;
    overflow: auto;
    min-width: 250px;
  }
  [am-select-button] {
    width: 190px;
  }
  [am-content] {
    width: calc(100% - 200px);
    min-width: 350px;
    .input-wrapper {
      width: 100%;
    }
  }
  [am-search-attr] {
    [am-block] {
      width: 250px;
    }
  }
  [am-attr-result] {
    max-height: 350px;
    overflow: auto;
  }
  [am-del-field-icon] {
    display:inline-grid;
  }
}
</style>
